// extracted by mini-css-extract-plugin
export default {"container":"LinkCursorSelection-module__container--rszxN","link":"LinkCursorSelection-module__link--Imjx8"};